import classNames from "classnames";

interface ToggleProps {
    onClick: () => void;
    isOn: boolean;
    enabled?: boolean;
}

const Toggle = ({ onClick, isOn, enabled = true }: ToggleProps) => {

    const buttonState = classNames(
        `relative inline-flex flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors ease-in-out duration-200 h-7 w-12 disabled:cursor-not-allowed focus-visible:outline-focus-ring`,
        { "bg-neutral-200": !isOn },
        { "bg-neutral-950": isOn },
        { "opacity-40": !enabled }
    );

    const circleState = classNames(
        `pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`,
        { "translate-x-0": !isOn },
        { "translate-x-[20px]": isOn }
    );

    return (
        <button
            name="autopay-toggle"
            type="button"
            className={buttonState}
            role="switch"
            aria-checked={isOn}
            onClick={onClick}
            disabled={!enabled}
        >
            <span className="sr-only">Toggle autopay</span>
            <span className={circleState} />
        </button>
    );
};

export default Toggle;
